import { useEffect, useContext } from 'react';

import { ShowcaseContext } from ':constants';
export const BrowserTitle = ({ title }: { title?: string }): null => {
  const showcaseInfo = useContext(ShowcaseContext);

  useEffect(() => {
    const showcaseName = showcaseInfo ? showcaseInfo.name : '';
    document.title = `${title ?? ''}${
      title && showcaseName ? ' - ' : ''
    }${showcaseName}`;
  }, [title, showcaseInfo]);

  return null;
};
